const l = (t, e) => {
  let o = document.createElement("A");
  o.href = t, o.target = "_blank", e && (o.download = e), o.onclick = (n) => n.stopPropagation(), document.body.appendChild(o), o.click(), document.body.removeChild(o);
}, c = (t, e) => t ? t.blob ?? new File([], t.name) : e, d = (t) => {
  const e = ["B", "kB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"], o = t > 0 ? Math.floor(Math.log(t) / Math.log(1024)) : 0;
  return `${(t / Math.pow(1024, o)).toFixed(2)} ${e[o]}`;
}, r = {
  downloadFile: l,
  getBlobFromFile: c,
  getFileSize: d
};
export {
  r as FileUtils,
  l as downloadFile,
  c as getBlobFromFile,
  d as getFileSize
};
